import { AcademyFormComponent } from "Components/Shared";

const AddAcademy = () => {
  return <AcademyFormComponent isEditAcademy={false} />;
};

export default AddAcademy;
